var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.taskTabMetaData.componentName,_vm._b({ref:_vm.taskTabMetaData.myRefName,tag:"component"},'component',_vm.taskTabMetaData.props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }